if (!customElements.get('osevra-hero-carousel')) {
  customElements.define(
    'osevra-hero-carousel',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.osevra-hero-carousel__track');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        this.updateSlideAccessibility();
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot), true)));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.start();
      }

      show(nextIndex, userInitiated = false) {
        this.index = (nextIndex + this.slides.length) % this.slides.length;
        this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
        this.updateSlideAccessibility();
        this.dots.forEach((dot, index) => {
          if (index === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (userInitiated) this.start();
      }

      updateSlideAccessibility() {
        this.slides.forEach((slide, index) => {
          const isCurrent = index === this.index;
          slide.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
          slide.toggleAttribute('inert', !isCurrent);
        });
      }

      start() {
        this.stop();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = window.setInterval(() => this.show(this.index + 1), 6500);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
      }

      disconnectedCallback() {
        this.stop();
      }
    }
  );
}

const ensureOsevraFooterDiscoveryLinks = () => {
  const footer = document.querySelector('footer');
  if (!footer || footer.querySelector('.osevra-footer-discovery-links')) return;

  const nav = document.createElement('nav');
  nav.className = 'osevra-footer-discovery-links';
  nav.setAttribute('aria-label', 'Fragrance journal and store policies');

  [
    ['/blogs/fragrance-journal', 'Fragrance journal'],
    ['/policies/refund-policy', 'Refund policy'],
    ['/policies/terms-of-service', 'Terms of service'],
  ].forEach(([href, label]) => {
    const link = document.createElement('a');
    link.href = href;
    link.textContent = label;
    nav.append(link);
  });

  footer.append(nav);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ensureOsevraFooterDiscoveryLinks, { once: true });
} else {
  ensureOsevraFooterDiscoveryLinks();
}
